export default {
	'daily-journal': 'ملخص اليوم',
	'sales-refunds': 'مبيعات / مرتجعات',
	'purchase-refunds': 'مشتريات / مرتجعات',
	'in-out-cashbox': 'مقبوضات / مدفعوعات الصندوق',
	total: 'المجموع',
	'cash-total': 'الملبغ النقدي',
	'card-total': 'مبلغ البطاقة',
	'unposted-amount': 'مبلغ غير مرحل',
}